import type { PlayerMission } from '@killer-party/contracts';

// Ecran joueur qui correspond au statut d'une mission (TD-005).
export type MissionPage = 'briefing' | 'mission' | 'debrief' | 'victory';

// null : agent parti du lobby (mission ABORTED jamais demarree, TD-012), il n'a plus d'ecran.
export function missionPage(
  mission: Pick<PlayerMission, 'statusCode' | 'startedAt'>,
): MissionPage | null {
  switch (mission.statusCode) {
    case 'READY':
      return 'briefing';
    case 'STARTED':
      return 'mission';
    case 'SUCCEEDED':
      return 'victory';
    case 'FAILED':
      return 'debrief';
    case 'ABORTED':
      return mission.startedAt ? 'debrief' : null;
  }
}
